import { BorderRadiusMedium, ColorNeutralWhite, Spacing8, Spacing16 } from 'autogen/design-tokens/tokens';
import type { ConnectedContentAdvisorModel } from 'autogen/swagger/all';
import React from 'react';
import styled from 'styled-components';

const AuthorWrapper = styled.div`
    position: absolute;
    bottom: ${Spacing16};
    display: flex;
    align-items: center;
    padding: ${Spacing8};
    max-width: calc(100% - ${Spacing16});
    background-color: rgb(from ${ColorNeutralWhite} r g b / 40%);
    border-radius: ${BorderRadiusMedium};
    backdrop-filter: blur(6px);
`;

const AuthorImageContainer = styled.div`
    flex: none;
    border-radius: 50%;
    overflow: hidden;
    width: 24px;
    height: 24px;
    border: 1px solid rgb(from ${ColorNeutralWhite} r g b / 80%);
    margin-right: ${Spacing8};
`;

const AuthorImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const AuthorName = styled.div``;

interface IAdvisor {
    advisorModel?: ConnectedContentAdvisorModel;
}

export default function Author(props: IAdvisor) {
    const { advisorModel } = props;

    if (!advisorModel) {
        return null;
    }

    return (
        <AuthorWrapper>
            <AuthorImageContainer>
                <AuthorImage src={advisorModel.imageUrl} alt="" />
            </AuthorImageContainer>
            <AuthorName>
                Af <b>{advisorModel.fullName}</b>
            </AuthorName>
        </AuthorWrapper>
    );
}
